module.exports = __webpack_public_path__ + "img/sencha_2.af730323.jpg";